import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as passwordSetupState } from "./redux";

/**
 * Direct selector to the passwordSetupPage state domain
 */

export const passwordSetupDomain: (any) => passwordSetupState = (state) =>
  state.passwordSetup || initialState;

/**
 * Custom selectors to the passwordSetupPage state
 */
export const selectpasswordSetup = createSelector(
  passwordSetupDomain,
  (substate) => substate
);
export const selectTermsAndConditions = createSelector(
  passwordSetupDomain,
  (substate) => substate.termsAndCondition
);

export const getPasswordPolicies = createSelector(
  passwordSetupDomain,
  (substate) => substate.passwordPolicies
);

export const getUserName = createSelector(
  passwordSetupDomain,
  (substate) => substate.userInfo.preferred_username
);

export const selectUserInfo = createSelector(
  passwordSetupDomain,
  (substate) => substate.userInfo
);

export const selectLoadingUserInfo = createSelector(
  passwordSetupDomain,
  (substate) => substate.loadingUserInfo
);

export const selectLoadingPasswordPolicies = createSelector(
  passwordSetupDomain,
  (substate) => substate.loadingPasswordPolicies
);

export const passwordActivationFailure = createSelector(
  passwordSetupDomain,
  (substate) => substate.passwordUpdateFailure
);

export const activation = createSelector(
  passwordSetupDomain,
  (substate) => substate.isAccountActivated
);

export const termsAndConditionFile = createSelector(
  passwordSetupDomain,
  (substate) => substate.termsAndConditionFile
);

export const selectNoTermsAndConditions = createSelector(
  passwordSetupDomain,
  (substate) => substate.noTermsAndConditions
);

export const selectRetries = createSelector(
  passwordSetupDomain,
  (substate) => substate.noOfRetries
);

export const selectApiError = createSelector(
  passwordSetupDomain,
  (substate) => substate.apiError
);

export const selectUsernameUpdateError = createSelector(
  passwordSetupDomain,
  (substate) => substate.usernameUpdateError
);

export const selectValidatingUsername = createSelector(
  passwordSetupDomain,
  (substate) => substate.validatingUsername
);

export const selectCheckedUsername = createSelector(
  passwordSetupDomain,
  (substate) => substate.checkedUsername
);

export const selectIsUsernameUnique = createSelector(
  passwordSetupDomain,
  (substate) => substate.isUsernameUnique
);

export const selectUsernameValidationErrorType = createSelector(
  passwordSetupDomain,
  (substate) => substate.usernameValidationErrorType
);

// add structured selectors here, which will be mapped as prop to scene component
export const selectPasswordSetupProps = createStructuredSelector({
  passwordSetup: selectpasswordSetup,
  termsAndCondition: selectTermsAndConditions,
  noTermsAndConditions: selectNoTermsAndConditions,
  userName: getUserName,
  passwordPolicies: getPasswordPolicies,
  userInfo: selectUserInfo,
  loadingUserInfo: selectLoadingUserInfo,
  loadingPasswordPolicies: selectLoadingPasswordPolicies,
  passwordFailure: passwordActivationFailure,
  isAccountActivated: activation,
  termsAndConditionContent: termsAndConditionFile,
  noOfRetries: selectRetries,
  apiError: selectApiError,
  usernameUpdateError: selectUsernameUpdateError,
  validatingUsername: selectValidatingUsername,
  checkedUsername: selectCheckedUsername,
  isUsernameUnique: selectIsUsernameUnique,
  usernameValidationErrorType: selectUsernameValidationErrorType,
});
